/** Инвалидация журнальных данных после мутаций (полёты, ТО, неисправности). */

const JOURNAL_EVENT = 'journal-data-changed';

export function notifyJournalChanged(): void {
  window.dispatchEvent(new Event(JOURNAL_EVENT));
}

export function onJournalChanged(handler: () => void): () => void {
  window.addEventListener(JOURNAL_EVENT, handler);
  return () => window.removeEventListener(JOURNAL_EVENT, handler);
}

/** После успешного ответа API — оповестить экраны. */
export function tapJournal<T>(promise: Promise<T>): Promise<T> {
  return promise.then((value) => {
    notifyJournalChanged();
    return value;
  });
}
